import type {Context} from '../types';

export default (context: Context) => {
  const {jsonNode} = context.node;
  const {data = {}} = jsonNode;

  const needed = jsonNode.type === 'FormBlockLabel' && data.users !== undefined;

  return {
    needed,
    logData: {
      msg: 'Remove data.users from FormBlockLabel',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // eslint-disable-next-line webflow/no-delete
      delete data.users;
    },
  };
};
